"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Observer = function (_a) {
    var children = _a.children, className = _a.className, onVisibleChange = _a.onVisibleChange;
    var container = react_1.useRef(null);
    react_1.useEffect(function () {
        var io;
        if (container.current) {
            io = new IntersectionObserver(function (_a) {
                var entry = _a[0];
                if (onVisibleChange)
                    onVisibleChange(entry.isIntersecting);
            });
            io.observe(container.current);
        }
        return function () { return io === null || io === void 0 ? void 0 : io.disconnect(); };
    }, [onVisibleChange, container]);
    return (react_1.default.createElement("div", { ref: container, className: className }, children));
};
exports.default = Observer;
//# sourceMappingURL=observer.js.map